import SerialWrapper from '../serialWrapper.jsx'
import API from './api.jsx'
import Lock from '../lock.jsx'

class ThermalDeviceAPI {
  constructor (options = {}) {
    this.wrapper = new SerialWrapper(options)
    this.lock = new Lock()
    this.api = new API(this.wrapper, this.lock)
  }

  connect () {
    return this.wrapper.open()
  }

  disconnect (config) {
    return this.wrapper.close(config)
  }

  isSerialPortOpen () {
    return this.wrapper.portOpened
  }

  async getSavedSerialPort () {
    return await this.wrapper.getSavedSerialPort()
  }

  async openSerialPort () {
    if (!this.isSerialPortOpen()) {
      await this.connect()
    }
  }

  async closeSerialPort () {
    if (this.isSerialPortOpen()) {
      await this.disconnect()
    }
  }

  async print (data) {
    try {
      await this.openSerialPort()

      const res = await this.api.print(data)

      setTimeout(async () => {
        await this.closeSerialPort()
      }, 2000)

      return {
        success: true,
        data: res
      }
    } catch (error) {
      // console.error('Error running cut paper:', error)
      // throw new Error('execution_error')
      return {
        success: false,
        data: error
      }
    }
  }
}

export default ThermalDeviceAPI
